import Cal, { getCalApi } from "@calcom/embed-react";
import { useEffect } from "react";
export default function MyApp() {
  useEffect(()=>{
	(async function () {
	  const cal = await getCalApi();
	  cal("ui", {"styles":{"branding":{"brandColor":"#1c3a5b"}},"hideEventTypeDetails":false,"layout":"month_view"});
	})();
  }, [])
  return <Cal 
	calLink="franco-perrone-38lcb7/reunion-estrategica-fhp"
	style={{width:"100%",height:"100%",overflow:"scroll"}}
	config={{layout: 'month_view'}}
  
	
  />;
};